var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownWhiteLeagues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61589 5.53907L2.18691 2.62429C1.24083 1.489 0.767793 0.921351 0.983562 0.460675C1.19933 -4.24413e-07 1.93824 -3.92114e-07 3.41607 -3.27516e-07L6.58393 -1.89044e-07C8.06176 -1.24447e-07 8.80067 -9.21477e-08 9.01644 0.460676C9.23221 0.921351 8.75917 1.489 7.81309 2.62429L7.81309 2.62429L5.38411 5.53907C5.2061 5.75268 5.11709 5.85949 5 5.85949C4.88291 5.85949 4.7939 5.75268 4.61589 5.53907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhiteLeagues);
export default __webpack_public_path__ + "static/media/arrow_down_white_leagues.03b52b97408c12e2f68fa992b5535f82.svg";
export { ForwardRef as ReactComponent };